import React from "react";
import _ from "lodash";
import clsx from "clsx";

import {makeStyles} from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import Collapse from "@material-ui/core/Collapse";

import {MissingRequiredIcon} from "../../../../components/Icons/WarningIcon";
import SkipIcon from "../../../../components/Icons/SkipIcon";
import {CONFIRMATION_STATE} from "../../constants";

import styles from "./styles";


const NO_PARENT = "no parent";

const warningUseStyles = makeStyles(() => ({
  warnIcon: {
    fontSize: '1.15em'
  }
}));

const SideMenuWarningIcon = () => {
  const classes = warningUseStyles();

  return <>&nbsp;<MissingRequiredIcon className={classes.warnIcon}/></>
};

const SideMenuSkipIcon = () => {
  const classes = warningUseStyles();

  return <>&nbsp;<SkipIcon className={classes.warnIcon}/></>
};

const SideMenuItem = ({group, classes, isStepSelectedCheck, onGoToStepClick}) => {
  const [isExpanded, setIsExpanded] = React.useState(group.parent === NO_PARENT || group.selected);

  const onGroupClick = () => {
    setIsExpanded(!isExpanded)
  };

  const renderListItem = (groupItem) => {
    const step = groupItem.step;
    const isSelected = isStepSelectedCheck(step);
    const goToStep = !isSelected ? onGoToStepClick : undefined;
    const nested = group.parent !== NO_PARENT;

    return (
      <ListItem
        key={step.uid}
        classes={{
          root: clsx(classes.listItemRoot, nested && classes.listItemRootNested, !!goToStep && classes.listItemRootClickable),
          selected: clsx(classes.listItemSelected, nested && 'nested')
        }}
        selected={isSelected}
        onClick={goToStep && (() => goToStep(step.uid))}
        button={!!goToStep}
      >
        {step.category}
        {groupItem.hasMissingInfo
          ? <SideMenuWarningIcon />
          : groupItem.isSkipped && <SideMenuSkipIcon />
        }
      </ListItem>
    )
  };

  return (
    <>
      {group.parent !== NO_PARENT && (
        <ListItem
          classes={{root: clsx(classes.listItemRoot, classes.listItemRootClickable), selected: classes.listItemSelected}}
          selected={group.selected}
          onClick={onGroupClick}
          button
        >
          {group.parent}
          {group.hasMissingInfo
            ? <SideMenuWarningIcon />
            : group.hasSkipped && <SideMenuSkipIcon />
          }
        </ListItem>
      )}
      <Collapse in={isExpanded} timeout="auto" unmountOnExit>
        <List disablePadding>
          {group.items.map(renderListItem)}
        </List>
      </Collapse>
    </>
  )
};

const SideMenu = (props) => {
  const {
    classes,
    dataService,
    onGoToStepClick,
  } = props;

  if (!dataService) return null;

  const isStepSelectedCheck = (step) => step.uid === _.get(dataService.step, 'uid');

  const groupedSteps = React.useMemo(() => {
    const groupedData = [];
    let lastParent;

    dataService.steps.forEach((item, idx) => {
      const parentKey = item.parent || NO_PARENT;
      if (parentKey !== lastParent) {
        groupedData.push({ parent: parentKey, selected: false, hasMissingInfo: false, hasSkipped: false, items: [] });
        lastParent = parentKey;
      }
      const group = _.last(groupedData);
      if(!group.selected) {
        group.selected = isStepSelectedCheck(item)
      }

      const hasMissingInfo = !!item.confirmationState && dataService.checkHasMissingAnswers(item);
      const isSkipped = item.confirmationState === CONFIRMATION_STATE.SKIPPED;

      group.items.push({step: item, hasMissingInfo, isSkipped});
      if(!group.hasMissingInfo) {
        group.hasMissingInfo = hasMissingInfo;
      }
      if(!group.hasSkipped) {
        group.hasSkipped = isSkipped;
      }
    });

    return groupedData;
  }, [dataService.steps, dataService.steps.length]); // added length check cause adding/removing items will not be detected as array remains the same object

  return (
    <div className={classes.menuContainer}>
      {groupedSteps.map((group, idx) => (
        <SideMenuItem
          key={idx}
          group={group}
          classes={classes}
          isStepSelectedCheck={isStepSelectedCheck}
          onGoToStepClick={onGoToStepClick}
        />
      ))}
    </div>
  )
};

export default withStyles(styles)(SideMenu);